import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-principal-message',
  templateUrl: './alumni-principal-message.component.html',
  styleUrls: ['./alumni-principal-message.component.scss']
})
export class AlumniPrincipalMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
